import { useContext } from 'react'
import { MarkupContext } from '../../providers/Markup'
import { hasRenderableText } from '../../helpers/markup'

const TitleBlock = (props) => {
  const { createMarkup } = useContext(MarkupContext)
  // Extract text alignment classes from headingClass if present
  const headingClass = props.headingClass ?? ''
  const descriptionClass = props.descriptionClass ?? '';

  // Gate on real text content, not raw string truthiness: RTE values like `<h2></h2>`
  // are truthy but render an empty heading (an a11y violation).
  const showTitle = hasRenderableText(props.title)
  const showDescription = hasRenderableText(props.description)

  let textAlignClass = ''
  if (headingClass.includes('text-center')) {
    textAlignClass = 'text-center'
  } else if (headingClass.includes('text-right')) {
    textAlignClass = 'text-right'
  } else if (headingClass.includes('text-left')) {
    textAlignClass = 'text-left'
  }

  return (
    <>
      {(showTitle || showDescription) && (
        <div className={`${headingClass}`}>
          {showTitle && (
            <div
              data-type="section-title"
              className={`font-highlight max-w-[var(--readable-content-max-width,none)] ${textAlignClass}`}
              data-rte="true"
              dangerouslySetInnerHTML={createMarkup(props.title)}
            ></div>
          )}
          {showDescription && (
            <div
              className={`${showTitle && 'mt-10'} ${descriptionClass} max-w-[var(--readable-content-max-width,none)] ${textAlignClass}`}
              data-type="section-description"
              data-rte="true"
              dangerouslySetInnerHTML={createMarkup(props.description)}
            ></div>
          )}
        </div>
      )}
    </>
  )
}

export default TitleBlock
